import { render } from "./behno-team-new-banner.vue?vue&type=template&id=01c60de6&scoped=true"
import script from "./behno-team-new-banner.vue?vue&type=script&lang=js"
export * from "./behno-team-new-banner.vue?vue&type=script&lang=js"

import "./behno-team-new-banner.vue?vue&type=style&index=0&id=01c60de6&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c60de6"]])

export default __exports__